import React from "react";
import { useTranslation } from 'react-i18next';
import SeoHead from "../seo/SeoHead";
import ServicePage, { RelatedServices, ServiceChecklist, ServiceCta, ServiceFaq, ServiceHero } from "./ServicePageLayout";
import PreInspectImg from "../../assets/service-pre-purchase-hero.jpg";

const PreInspect = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const lang = i18n.language === 'en' ? 'en' : 'ar';
    const faq = t('preInspectPage.faq', { returnObjects: true });

    return (
        <ServicePage isRTL={isRTL}>
            <SeoHead
                path="services/pre-purchase-inspections"
                title={t('preInspectPage.metaTitle')}
                description={t('preInspectPage.metaDescription')}
                keywords={t('preInspectPage.keywords')}
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: faq.map(({ q, a }) => ({
                        '@type': 'Question',
                        name: q,
                        acceptedAnswer: { '@type': 'Answer', text: a },
                    })),
                }}
            />

            <ServiceHero
                eyebrow={t('preInspectPage.eyebrow')}
                title={t('preInspectPage.title')}
                intro={t('preInspectPage.description', { companyName: isRTL ? 'البروفيسور لفحص السيارات' : 'Al Professor Technical Inspection', location: isRTL ? 'أبوظبي' : 'Abu Dhabi' })}
                image={PreInspectImg}
                imageAlt={t('preInspectPage.imageAlt')}
                ctaLabel={t('preInspectPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز فحص ما قبل الشراء.' : 'Hi, I would like to book a pre-purchase inspection.'}
            />

            <ServiceChecklist title={t('preInspectPage.coverTitle')} points={t('preInspectPage.coverPoints', { returnObjects: true })} />
            <ServiceChecklist eyebrow={t('preInspectPage.eyebrow')} title={t('preInspectPage.additionalTitle')} points={t('preInspectPage.additionalPoints', { returnObjects: true })} />
            <ServiceFaq title={t('preInspectPage.faqTitle')} items={faq} />
            <RelatedServices title={t('preInspectPage.related.title')} items={t('preInspectPage.related.items', { returnObjects: true })} lang={lang} />

            <ServiceCta
                eyebrow={t('preInspectPage.eyebrow')}
                title={t('preInspectPage.title')}
                body={t('preInspectPage.metaDescription')}
                ctaLabel={isRTL ? 'اطلب الفحص عبر واتساب' : 'Book on WhatsApp'}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز فحص ما قبل الشراء.' : 'Hi, I would like to book a pre-purchase inspection.'}
            />
        </ServicePage>
    );
};

export default PreInspect;
